const CURRENCY_SYMBOLS = {
    USD: "USD $",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    INR: "₹",
    ZAR: "R",
    IDR: "Rp",
};
const DEFAULT_CURRENCY_SYMBOL = "$";
export function getCurrencySymbol(currency) {
    if (!currency) {
        return DEFAULT_CURRENCY_SYMBOL;
    }
    return CURRENCY_SYMBOLS[currency] ?? `${currency} `;
}
